import { api } from './api'

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000'

export function notebookFileUrl(fileId) {
  return `${BASE_URL}/notebooks/files/${fileId}`
}

// All of the current user's notebook pages (flat list -> the client builds the
// tree from `parent`). Pass includeArchived=true to also get archived pages.
export function listNotebooks(includeArchived = false) {
  const query = includeArchived ? '?archived=1' : ''
  return api.get(`/notebooks${query}`).then((data) => data.notebooks)
}

// One page with its blocks and populated facets (authors/items).
export function getNotebook(id) {
  return api.get(`/notebooks/${id}`).then((data) => data.notebook)
}

// Create a top-level notebook, or a nested page when { parent } is provided.
// Payload: { title?, parent? }.
export function createNotebook(payload) {
  return api.post('/notebooks', payload).then((data) => data.notebook)
}

// Partial update: { title?, description?, icon?, cover?, blocks?, authors?,
// items?, standards?, textTypes?, archived? }.
export function updateNotebook(id, changes) {
  return api.patch(`/notebooks/${id}`, changes).then((data) => data.notebook)
}

// Delete a page and all of its descendants. Resolves to { deleted: <count> }.
export function deleteNotebook(id) {
  return api.del(`/notebooks/${id}`)
}

// Upload one image or PDF for a notebook block. Resolves to
// { fileId, name, contentType, size }.
export async function uploadNotebookFile(file) {
  const form = new FormData()
  form.append('file', file)
  const res = await fetch(`${BASE_URL}/notebooks/upload`, {
    method: 'POST',
    credentials: 'include',
    body: form,
  })
  if (!res.ok) {
    let message = 'Upload failed'
    try {
      const data = await res.json()
      message = data.error || message
    } catch {
      /* non-JSON error */
    }
    throw new Error(message)
  }
  const data = await res.json()
  return data.file
}
